import { QuantityInput } from '../../../components/Form/QuantityInput';
import { RadioButton } from '../../../components/Form/RadioButton';
import { Select } from '../../../components/Select/Select';
import { Updater } from '../../../hooks/useImmer';
import { useTranslation } from '../../../i18n/i18n';
import { ApiSchedule } from '../../../types';

type Weekday = {
	id: number;
	text: string;
};

interface MonthPatternFormProps {
	schedule: ApiSchedule;
	setSchedule: Updater<ApiSchedule>;
}

export const MonthPatternForm = ({ schedule, setSchedule }: MonthPatternFormProps): JSX.Element => {
	const t = useTranslation().subscriptions;
	const sortedList = ['1', '2', '3', '4', '-1'].map((i) =>
		Object.values(t.schedule.counters).find((counter) => counter.id.toString() == i)
	);
	const weekdayValues = Object.values(t.schedule.weekdays);

	return (
		<>
			<p style={{ marginBottom: 0 }}>{t.schedule.on}</p>
			<div className="form-row">
				<RadioButton
					checked={schedule.monthlyInterval === 'date'}
					group="month_interval"
					value="date"
					onChange={() =>
						setSchedule((draft: ApiSchedule) => {
							draft.monthlyDay = draft.monthlyDay ? draft.monthlyDay : 1;
							draft.monthlyInterval = 'date';
						})
					}
				>
					{''}
				</RadioButton>
				<QuantityInput
					maxValue={31}
					iconSize={19}
					disabled={schedule.monthlyInterval === 'weekday'}
					defaultValue={schedule?.monthlyDay || 1}
					step={1}
					onBlur={(e) => {
						setSchedule((draft: ApiSchedule) => {
							draft.monthlyDay = e;
						});
					}}
				/>
			</div>
			<div className="form-row">
				<RadioButton
					checked={schedule.monthlyInterval === 'weekday'}
					group="month_interval"
					value="weekday"
					onChange={() => setSchedule((draft) => void (draft.monthlyInterval = 'weekday'))}
				>
					{''}
				</RadioButton>
				<Select
					large
					disabled={schedule.monthlyInterval === 'date'}
					placeholder={t.schedule.pickOccurence}
					list={sortedList}
					renderValue={(value: Weekday) => sortedList.find((c) => c?.id === value.id)?.text || ''}
					searchValue={(query: string, list: Weekday[]) => list.find((s) => s.id.toString() === query)}
					value={schedule?.monthlyWeekdayCounter ? schedule.monthlyWeekdayCounter.toString() : null}
					onSelect={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
						setSchedule(
							(draft) => void (draft.monthlyWeekdayCounter = parseInt((e.target as HTMLElement).id))
						)
					}
					idField="id"
				/>
				<Select
					large
					disabled={schedule.monthlyInterval === 'date'}
					placeholder={t.schedule.weekday}
					searchValue={(query: string, list: Weekday[]) => list.find((s) => s.id.toString() === query)}
					list={weekdayValues.sort((a, b) => (a.id === 0 ? 7 : a.id - b.id))}
					renderValue={(value: Weekday) =>
						weekdayValues.find((s) => s.id === value.id)?.text + t.schedule.definiteFormSuffix || ''
					}
					value={schedule?.monthlyWeekday?.toString()}
					onSelect={(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void =>
						setSchedule((draft) => void (draft.monthlyWeekday = parseInt((e.target as HTMLElement).id)))
					}
					idField="id"
				/>
			</div>
		</>
	);
};
